import { TableConfig } from '@constants/table.constants';
import { GridSortItem } from '@mui/x-data-grid-pro';
import { createStore, withProps } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';
import { TablePagination } from '@store/common/pagination.model';
import { AuditOfferFollowUp, AuditOfferFollowUpFilters, AuditOfferFollowUpResponseDto, AuditOfferLightDto, AuditProposalResponseDto, ProposalSupplierActivities } from '../audit-offer-followUp/audit-offer-followUp.model';

export interface AuditFollowUpState {
  proposalResponse?: AuditOfferFollowUpResponseDto;
  activities?: ProposalSupplierActivities[];
  auditsProposalDetails?: AuditProposalResponseDto;
  allAuditsOfferFromProposal?: AuditOfferLightDto[];
  filters: AuditOfferFollowUpFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const auditOfferFollowUpStore = createStore(
  { name: 'auditOfferFollowUp' },
  withEntities<AuditOfferFollowUp>(),
  withProps<AuditFollowUpState>({
    filters: {search: '', tableFilters: AuditOfferFollowUpFilters.initTableFilters()},
    sort: {
      field: 'organisation.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withPagination(),
  withRequestsStatus()
);

